// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
}

:root {
  --logo-blue: rgb(40, 82, 154);
  --logo-gold: rgb(242, 202, 88);
  --logo-blue-op: rgba(40, 82, 154, 0.9);
}

.content-container {
  min-height: calc(100vh - 92px);
}

/* -----HEADER----- */

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--logo-blue);
  box-shadow: 0 2px 10px black;
  overflow: hidden;
}

.logo {
  width: 300px;
}

.header-nav {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.header-text {
  text-decoration: none;
  padding: 20px;
  color: var(--logo-gold);
  font-weight: bold;
  font-size: large;
  transition: box-shadow 0.3s ease-in-out;
  border-radius: 15px;
  margin: 10px;
}

.header-nav > a:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
}

.mobile-header-wrap {
  display: flex;
  flex-direction: row;
}

.hamburger-wrapper {
  display: flex;
  align-items: center;
}

.hide-me {
  display: none;
}

.show-me {
  display: block;
}

.header-text.active {
  background-color: var(--logo-gold);
  color: var(--logo-blue);
}

/* -----HOME----- */

.main-h1-h4 {
  display: flex;
  flex-direction: column;
  padding-left: 40px;
  padding-top: 40px;
  padding-right: 40px;
  line-height: 2em;
}

.main-h1 {
  margin-bottom: 10px;
}

.main-button-image-div {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.main-button {
  height: -moz-fit-content;
  height: fit-content;
  padding: 15px;
  border: none;
  border-radius: 15px;
  background-color: var(--logo-blue);
  color: var(--logo-gold);
  font-weight: bold;
  font-size: large;
  cursor: pointer;
}

.main-image {
  border-radius: 15px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
}

/* -----HOME: TECHNOLOGIES----- */

.technologies-wrapper {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  width: 90%;
  margin: auto;
  margin-top: 40px;
  margin-bottom: 40px;
  text-align: center;
  border-radius: 15px;
}

.technologies-wrapper > h2 {
  padding-top: 20px;
}

.technologies {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.one-technology-wrapper {
  padding: 20px;
  display: flex;
  flex-direction: row;
  margin: auto;
  align-items: center;
  width: 250px;
  justify-content: space-between;
}

/* ----HOME: CONTACT----- */
#contact-wrapper {
  width: 60%;
  margin: auto;
  margin-top: 40px;
  margin-bottom: 40px;
  padding: 40px 40px 10px 40px;
  background-color: var(--logo-blue-op);
  color: var(--logo-gold);
  font-weight: bold;
  border-radius: 15px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
}

#contact-wrapper > h2 {
  text-align: center;
}

#contact-wrapper > form {
  display: flex;
  flex-direction: column;
}

.first-last-name, .email-company {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.firstname, .lastname, .email, .company, .message{
  display: flex;
  flex-direction: column;
}

.message {
  width: 80%;
  margin: auto;
}

.firstname > label, .lastname > label, .email > label, .company > label, .message > label {
  margin-bottom: 10px;
  margin-top: 20px;
}

.firstname > input, .lastname > input, .email > input, .company > input {
  padding: 10px;
  width: 250px;
  border: none;
  background-color: var(--input-bckgnd);
  border: none;
  border-bottom: 2px solid var(--logo-gold);
  color: white;
  font-size: large;
}

.message > textarea {
  background-color: var(--input-bckgnd);
  border: 2px solid var(--logo-gold);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
  sans-serif;;
  color: white;
  font-size: large;
}


.submit-btn-div {
  margin: auto;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 10px;
}

/* -----ABOUT US----- */

.about-us-wrapper > h1 {
  padding-bottom: 20px;
  text-align: center;
}

.about-us-h4 {
  margin: auto;
  margin-top: 10px;
  margin-bottom: 30px;
  width: 75%;
  line-height: 1.75em;
}

.about-us-card {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  border-radius: 15px;
  width: 300px;
  margin: auto;
  margin-bottom: 20px;
  padding: 30px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.about-us-card > img {
  border-radius: 15px;
  margin-right: 10px;
}

.about-us-card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}

.about-us-description > h2 {
  margin-bottom: 5px;
  margin-top: 5px;
  text-align: center;
}

.about-us-description > p {
  line-height: 1.4em;
}

/* -----WHAT WE DO----- */
.what-we-do-wrapper, .how-we-do-it-wrapper, .about-us-wrapper {
  padding: 40px;
  margin: auto;
}

.what-we-do-wrapper > h1, .how-we-do-it-wrapper > h1, .about-us-wrapper > h1 {
  text-align: center;
}

.one-what-we-do, .one-how-we-do-it {
  padding: 20px;
  line-height: 2em;
}

.icon-h3-wrapper {
  display: flex;
  flex-direction: row;
}

.icon-h3-wrapper > h3 {
  margin-left: 5px;
}

/* -----FOOTER----- */
.footer {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 10px;
  background-color: var(--logo-blue);
  color: var(--logo-gold);
}

.footer-nav-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.footer > div > nav > a, .email-div > a {
  text-decoration: none;
  color: var(--logo-gold);
  font-size: small;
}

.footer-nav-1 {
  line-height: 1.5em;
}

.footer-nav-2 {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.email-div {
  display: flex;
  align-items: center;
}

.email-div > a {
  margin-right: 5px;
}

.location-div {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.location-div > p {
  margin-right: 5px;
  font-size: small;
}

.copyright {
  font-size: x-small;
  text-align: center;
  margin-top: 10px;
}

/* -----HOW WE DO IT----- */

/* -----MEDIA QUERIES----- */
@media only screen and (max-width: 800px){

  .header-nav-top {
    display: flex;
    flex-direction: row;
    width: 100vw;
    justify-content: space-between;
  }

  .hamburger-wrapper {
    display: flex;
    justify-content: flex-end;
  }
  
  .header.is-open {
    display: flex;
    flex-direction: column;
  }

  .header-nav {
    display: none;
  }

  .header-nav.is-open {
    display:flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
  }

  .header-nav.is-open > .header-text {
    padding: 10px;
    margin: 5px;
  }

  .hamburger-nav {
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .hamburger {
    padding: 30px;
  }

  .hamburger.hide-me {
    padding: 0;
  }

  .hamburger :hover {
    cursor: pointer;;
  }

  .main-button-image-div {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }

  .main-button {
    margin: 20px 0px
  }

  .about-us-h4 {
    margin: auto;
    margin-bottom: 20px;
  }

  .about-us-card {
    display: flex;
    flex-direction: column;
    width: min-content;
  }

  .about-us-description {
    margin-top: 10px;
  }

  #contact-wrapper {
    width: 70%;
  }

  #contact-wrapper > h2 {
    margin-bottom: 20px;
  }

  .first-last-name, .email-company {
    display: flex;
    flex-direction: column;
    margin: auto;
  }

  .message {
    width: 100%
  }
}

@media only screen and (max-width: 1100px) {

  .about-us-card {
    display: flex;
    flex-direction: column;
    width: min-content;
  }
  
  .about-us-description {
    margin-top: 10px;
  }
}

@media only screen and (min-width: 1100px) {
  .main {
    width: 75%; 
    margin: auto;
    margin-bottom: 40px;
  }

  .main-button-image-div {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
  }

  .main-button {
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .technologies-wrapper {
    width: 75%;
    margin: auto;
    margin-bottom: 40px;
  }

  .what-we-do-wrapper, .how-we-do-it-wrapper, .about-us-wrapper {
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: left;
  }

  .about-us-wrapper {
    width: 75%;
    margin: auto;
  }

  .about-us-card {
    width: 400px;
  }

  #contact-wrapper {
    width: 50%;
  }

}

@media only screen and (max-width: 1700px) {
  .what-we-do-wrapper, .how-we-do-it-wrapper, .about-us-wrapper {
    width: 75%;
  }
}

@media only screen and (min-width: 1700px) {
  .main {
    width: 50%; 
    margin: auto;
    margin-bottom: 40px;
  }

  .main-button-image-div {
    margin-top: 20px;
  }

  .technologies-wrapper {
    width: 50%;
    margin: auto;
    margin-bottom: 40px;
  }

  .what-we-do-wrapper, .how-we-do-it-wrapper, .about-us-wrapper {
    width: 50%;
  }

  .about-us-wrapper {
    width: 75%;
    margin: auto;
  }

  #contact-wrapper {
    width: 40%;
  }

}

@media only screen and (min-width: 2100px) {
  .main, .technologies-wrapper {
    width: 40%;
  }

  #contact-wrapper {
    width: 30%
  }

  .about-us-h4 {
    width: 35%;
  }

} `, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA,iCAAiC;;AAEjC;EACE,uCAAuC;EACvC,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC;;YAEU;EACV,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uBAAuB;;AAEvB;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2BAA2B;;AAE3B,4BAA4B;AAC5B;;EAEE;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE;EACF;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE;EACF;AACF;;AAEA;;EAEE;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;AAEF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;AAEF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE;EACF;;EAEA;IACE,UAAU;EACZ;;AAEF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --logo-blue: rgb(40, 82, 154);\n  --logo-gold: rgb(242, 202, 88);\n  --logo-blue-op: rgba(40, 82, 154, 0.9);\n}\n\n.content-container {\n  min-height: calc(100vh - 92px);\n}\n\n/* -----HEADER----- */\n\n.header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--logo-blue);\n  box-shadow: 0 2px 10px black;\n  overflow: hidden;\n}\n\n.logo {\n  width: 300px;\n}\n\n.header-nav {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.header-text {\n  text-decoration: none;\n  padding: 20px;\n  color: var(--logo-gold);\n  font-weight: bold;\n  font-size: large;\n  transition: box-shadow 0.3s ease-in-out;\n  border-radius: 15px;\n  margin: 10px;\n}\n\n.header-nav > a:hover {\n  box-shadow: 0 5px 15px rgba(0,0,0,0.3);\n}\n\n.mobile-header-wrap {\n  display: flex;\n  flex-direction: row;\n}\n\n.hamburger-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.hide-me {\n  display: none;\n}\n\n.show-me {\n  display: block;\n}\n\n.header-text.active {\n  background-color: var(--logo-gold);\n  color: var(--logo-blue);\n}\n\n/* -----HOME----- */\n\n.main-h1-h4 {\n  display: flex;\n  flex-direction: column;\n  padding-left: 40px;\n  padding-top: 40px;\n  padding-right: 40px;\n  line-height: 2em;\n}\n\n.main-h1 {\n  margin-bottom: 10px;\n}\n\n.main-button-image-div {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.main-button {\n  height: fit-content;\n  padding: 15px;\n  border: none;\n  border-radius: 15px;\n  background-color: var(--logo-blue);\n  color: var(--logo-gold);\n  font-weight: bold;\n  font-size: large;\n  cursor: pointer;\n}\n\n.main-image {\n  border-radius: 15px;\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n}\n\n/* -----HOME: TECHNOLOGIES----- */\n\n.technologies-wrapper {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  width: 90%;\n  margin: auto;\n  margin-top: 40px;\n  margin-bottom: 40px;\n  text-align: center;\n  border-radius: 15px;\n}\n\n.technologies-wrapper > h2 {\n  padding-top: 20px;\n}\n\n.technologies {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.one-technology-wrapper {\n  padding: 20px;\n  display: flex;\n  flex-direction: row;\n  margin: auto;\n  align-items: center;\n  width: 250px;\n  justify-content: space-between;\n}\n\n/* ----HOME: CONTACT----- */\n#contact-wrapper {\n  width: 60%;\n  margin: auto;\n  margin-top: 40px;\n  margin-bottom: 40px;\n  padding: 40px 40px 10px 40px;\n  background-color: var(--logo-blue-op);\n  color: var(--logo-gold);\n  font-weight: bold;\n  border-radius: 15px;\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n}\n\n#contact-wrapper > h2 {\n  text-align: center;\n}\n\n#contact-wrapper > form {\n  display: flex;\n  flex-direction: column;\n}\n\n.first-last-name, .email-company {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n}\n\n.firstname, .lastname, .email, .company, .message{\n  display: flex;\n  flex-direction: column;\n}\n\n.message {\n  width: 80%;\n  margin: auto;\n}\n\n.firstname > label, .lastname > label, .email > label, .company > label, .message > label {\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.firstname > input, .lastname > input, .email > input, .company > input {\n  padding: 10px;\n  width: 250px;\n  border: none;\n  background-color: var(--input-bckgnd);\n  border: none;\n  border-bottom: 2px solid var(--logo-gold);\n  color: white;\n  font-size: large;\n}\n\n.message > textarea {\n  background-color: var(--input-bckgnd);\n  border: 2px solid var(--logo-gold);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n  sans-serif;;\n  color: white;\n  font-size: large;\n}\n\n\n.submit-btn-div {\n  margin: auto;\n  text-align: center;\n  margin-top: 30px;\n  margin-bottom: 10px;\n}\n\n/* -----ABOUT US----- */\n\n.about-us-wrapper > h1 {\n  padding-bottom: 20px;\n  text-align: center;\n}\n\n.about-us-h4 {\n  margin: auto;\n  margin-top: 10px;\n  margin-bottom: 30px;\n  width: 75%;\n  line-height: 1.75em;\n}\n\n.about-us-card {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 15px;\n  width: 300px;\n  margin: auto;\n  margin-bottom: 20px;\n  padding: 30px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.about-us-card > img {\n  border-radius: 15px;\n  margin-right: 10px;\n}\n\n.about-us-card:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.about-us-description > h2 {\n  margin-bottom: 5px;\n  margin-top: 5px;\n  text-align: center;\n}\n\n.about-us-description > p {\n  line-height: 1.4em;\n}\n\n/* -----WHAT WE DO----- */\n.what-we-do-wrapper, .how-we-do-it-wrapper, .about-us-wrapper {\n  padding: 40px;\n  margin: auto;\n}\n\n.what-we-do-wrapper > h1, .how-we-do-it-wrapper > h1, .about-us-wrapper > h1 {\n  text-align: center;\n}\n\n.one-what-we-do, .one-how-we-do-it {\n  padding: 20px;\n  line-height: 2em;\n}\n\n.icon-h3-wrapper {\n  display: flex;\n  flex-direction: row;\n}\n\n.icon-h3-wrapper > h3 {\n  margin-left: 5px;\n}\n\n/* -----FOOTER----- */\n.footer {\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 20px;\n  padding-bottom: 10px;\n  background-color: var(--logo-blue);\n  color: var(--logo-gold);\n}\n\n.footer-nav-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.footer > div > nav > a, .email-div > a {\n  text-decoration: none;\n  color: var(--logo-gold);\n  font-size: small;\n}\n\n.footer-nav-1 {\n  line-height: 1.5em;\n}\n\n.footer-nav-2 {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.email-div {\n  display: flex;\n  align-items: center;\n}\n\n.email-div > a {\n  margin-right: 5px;\n}\n\n.location-div {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.location-div > p {\n  margin-right: 5px;\n  font-size: small;\n}\n\n.copyright {\n  font-size: x-small;\n  text-align: center;\n  margin-top: 10px;\n}\n\n/* -----HOW WE DO IT----- */\n\n/* -----MEDIA QUERIES----- */\n@media only screen and (max-width: 800px){\n\n  .header-nav-top {\n    display: flex;\n    flex-direction: row;\n    width: 100vw;\n    justify-content: space-between;\n  }\n\n  .hamburger-wrapper {\n    display: flex;\n    justify-content: flex-end;\n  }\n  \n  .header.is-open {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .header-nav {\n    display: none;\n  }\n\n  .header-nav.is-open {\n    display:flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 10px;\n  }\n\n  .header-nav.is-open > .header-text {\n    padding: 10px;\n    margin: 5px;\n  }\n\n  .hamburger-nav {\n    display:flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .hamburger {\n    padding: 30px;\n  }\n\n  .hamburger.hide-me {\n    padding: 0;\n  }\n\n  .hamburger :hover {\n    cursor: pointer;;\n  }\n\n  .main-button-image-div {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .main-button {\n    margin: 20px 0px\n  }\n\n  .about-us-h4 {\n    margin: auto;\n    margin-bottom: 20px;\n  }\n\n  .about-us-card {\n    display: flex;\n    flex-direction: column;\n    width: min-content;\n  }\n\n  .about-us-description {\n    margin-top: 10px;\n  }\n\n  #contact-wrapper {\n    width: 70%;\n  }\n\n  #contact-wrapper > h2 {\n    margin-bottom: 20px;\n  }\n\n  .first-last-name, .email-company {\n    display: flex;\n    flex-direction: column;\n    margin: auto;\n  }\n\n  .message {\n    width: 100%\n  }\n}\n\n@media only screen and (max-width: 1100px) {\n\n  .about-us-card {\n    display: flex;\n    flex-direction: column;\n    width: min-content;\n  }\n  \n  .about-us-description {\n    margin-top: 10px;\n  }\n}\n\n@media only screen and (min-width: 1100px) {\n  .main {\n    width: 75%; \n    margin: auto;\n    margin-bottom: 40px;\n  }\n\n  .main-button-image-div {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: row;\n  }\n\n  .main-button {\n    margin-bottom: 20px;\n    margin-top: 20px;\n  }\n\n  .technologies-wrapper {\n    width: 75%;\n    margin: auto;\n    margin-bottom: 40px;\n  }\n\n  .what-we-do-wrapper, .how-we-do-it-wrapper, .about-us-wrapper {\n    padding: 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n  }\n\n  .about-us-wrapper {\n    width: 75%;\n    margin: auto;\n  }\n\n  .about-us-card {\n    width: 400px;\n  }\n\n  #contact-wrapper {\n    width: 50%;\n  }\n\n}\n\n@media only screen and (max-width: 1700px) {\n  .what-we-do-wrapper, .how-we-do-it-wrapper, .about-us-wrapper {\n    width: 75%;\n  }\n}\n\n@media only screen and (min-width: 1700px) {\n  .main {\n    width: 50%; \n    margin: auto;\n    margin-bottom: 40px;\n  }\n\n  .main-button-image-div {\n    margin-top: 20px;\n  }\n\n  .technologies-wrapper {\n    width: 50%;\n    margin: auto;\n    margin-bottom: 40px;\n  }\n\n  .what-we-do-wrapper, .how-we-do-it-wrapper, .about-us-wrapper {\n    width: 50%;\n  }\n\n  .about-us-wrapper {\n    width: 75%;\n    margin: auto;\n  }\n\n  #contact-wrapper {\n    width: 40%;\n  }\n\n}\n\n@media only screen and (min-width: 2100px) {\n  .main, .technologies-wrapper {\n    width: 40%;\n  }\n\n  #contact-wrapper {\n    width: 30%\n  }\n\n  .about-us-h4 {\n    width: 35%;\n  }\n\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
